import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'
import { templateJson } from './json/templateJson'
import { useEffect } from 'react'

const SuccessDkabio = ({ completionMessage, setIsDkabio }) => {
  // console.log('shareUrl', shareUrl)
  // const completionMessage=''
  useEffect(() => {
    setIsDkabio(true)
  }, [])

  let mySuccessJson = {
    ...templateJson,
    // logo: 'https://i.postimg.cc/XYMPRVJD/DKABio-LOGO.png',
    showCompleteButton: false,
    completeText: '完成',
    completedHtml: '',
    pages: [
      {
        name: 'page0',
        elements: [
          {
            type: 'panel',
            elements: [
              {
                type: 'html',
                name: 'intro',
                html: completionMessage,
              },
            ],
            name: 'panel1',
          },
        ],
      },
    ],
  }
  const survey = new Model(mySuccessJson)

  survey.onAfterRenderSurvey.add(function (sender) {
    var completeButton = document.querySelector('#sv-nav-complete')
    if (completeButton) {
      completeButton.style.display = 'none'
    }
  })

  return (
    <>
      <Survey model={survey} />
    </>
  )
}

export default SuccessDkabio
